/** @format */

import React, { useEffect, useState, useRef } from "react";
import TableForm from "./tableForm";
import "../App.css";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";

const Form10 = () => {
  const [usrInfo, setUsrInfo] = useState("");
  async function getUsrInfo() {
    try {
      const resp = await fetch("http://localhost:5000/api/userinfo", {
        method: "GET",
        headers: { token: localStorage.token },
      });
      const parsRes = await resp.json();
      // console.log(parsRes);

      setUsrInfo(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [empRole, setEmpRole] = useState([]);
  const fetchRoles = async () => {
    const response = await fetch("//localhost:5000/api/getPositions");
    const data = await response.json();
    setEmpRole(data);
  };

  const [empDep, setEmpDep] = useState([]);
  const fectchDepartments = async () => {
    const response = await fetch("//localhost:5000/api/departments");
    const data = await response.json();
    setEmpDep(data);
  };

  const displayEmpDep = (id) => {
    for (let i = 0; i < empDep.length; i++) {
      if (empDep[i].dep_id === id) {
        return empDep[i].dep_name;
      }
    }
  };

  const displayEmpRole = (id) => {
    for (let i = 0; i < empRole.length; i++) {
      if (empRole[i].role_id === id) {
        return empRole[i].role_name;
      }
    }
  };

  useEffect(() => {
    getUsrInfo();
    fetchRoles();
    fectchDepartments();
  }, []);

  const [formData, setFormData] = useState({
    doc_type: "10",
    travel_order_destination: "",
    travel_order_reason: "",
    travel_order_trans_mean: "",
    travel_order_st_date: "",
    travel_order_en_date: "",
    travel_order_req_date: "",
    req_date: null,
    requester_id: null,
    dep_id: null,
    approver_1: null,
    approver_2: null,
    approver_3: null,
    approver_4: null,
    approver_5: null,
    approver_6: null,
    approver_7: null,
    approver_8: null,

    // ...
  });

  const combinedFormData = {
    ...formData,
  };

  console.log(formData);

  const handleSubmit = async (e) => {
    // e.preventDefault();

    // Make a fetch() request to submit the form data to the backend.
    const response = await fetch("http://localhost:5000/api/formSubmit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token,
      },
      body: JSON.stringify(combinedFormData),
    });

    // Check the response status code.
    if (response.status === 200) {
      // Success!
      document.getElementById("btn-submit-form").disabled = true;

      toast.current.show({
        severity: "success",
        summary: "succès",
        detail: "Demande envoyée",
      });
    } else {
      // Error!
      console.log("An error occurred while submitting the form data.");
    }
  };

  const [currentDate, setCurrentDate] = useState(new Date());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      req_date: currentDate,
      requester_id: usrInfo.emp_id,
      dep_id: usrInfo.department,
    });
  }, [currentDate]);

  //get approvers ----------------------------------------------

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch("http://localhost:5000/api/approvers");
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  //get documents -------------------------------------------

  const [docs, setDocs] = useState([]);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch("http://localhost:5000/api/documents");
    const data = await response.json();

    setDocs(data);
    // console.log(docs);
    let docLen = docs.length;

    if (docLen > 0) {
      setIsNotEmpty(true);
    }
  };

  // console.log(formData);

  //initialize approvers status for the request------------
  const [currentDocIsSelected, setCurrentDocIsSelected] = useState(false);
  const [currentDoc, setCurrentDoc] = useState([]);
  const getCurrentDoc = () => {
    // console.log(isNotEmpty);
    if (docs.length !== 0) {
      const current = docs.filter(
        (doc) => doc.doc_type_id == formData.doc_type
      );
      setCurrentDoc(current);
      setCurrentDocIsSelected(true);
    }
  };

  // console.log(currentDocIsSelected);

  // console.log(formData);
  const initializeApproversState = () => {
    if (currentDoc.length > 0) {
      const firstDoc = currentDoc;
      const currDoc = firstDoc[0];

      const currDocArray = Object.entries(currDoc);

      let filteredDocArray = currDocArray.filter(
        (innerArr) =>
          innerArr[0] !== "doc_type_id" && innerArr[0] !== "doc_tittle"
      );

      console.log(filteredDocArray);

      let updatedFormData = { ...formData };
      for (let i = 0; i < filteredDocArray.length; i++) {
        const key = filteredDocArray[i][0];
        const value = filteredDocArray[i][1];
        const fdKey = Object.entries(formData);
        for (let j = 0; j < fdKey.length; j++) {
          if ((value === 0) | (value === null)) {
            if (fdKey[j][0] == key) {
              updatedFormData[key] = null;
            }
          } else {
            updatedFormData[key] = false;
          }
        }
      }
      setFormData(updatedFormData);
    }
  };

  // console.log(formData);

  // console.log(formData.approver_1);

  //--------------------------------------------------------

  const [name, setName] = useState("");
  const [requesterId, setRequesterId] = useState("");

  async function getName() {
    try {
      const resp = await fetch("//localhost:5000/api/dashboard", {
        method: "GET",
        headers: { token: localStorage.token },
      });
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setRequesterId(parsRes.emp_id);
    } catch (err) {
      console.error(err.message);
    }
  }
  useEffect(() => {
    getName();
    fetchDocs();
    fetchAppro();
    getCurrentDoc();
  }, []);

  useEffect(() => {
    getCurrentDoc();
  }, [docs]);

  useEffect(() => {
    initializeApproversState();
  }, [currentDoc]);

  const dataValidation = () => {
    if ((formData.ref_field == "") | (formData.supplier_name == "")) {
      document.getElementById("btn-submit-form").disabled = true;
    } else {
      document.getElementById("btn-submit-form").disabled = false;
    }
  };

  useEffect(() => {
    dataValidation();
  }, [formData.ref_field, formData.supplier_name]);

  // confirmation dialog -------------------------------------------

  const toast = useRef(null);

  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "conifrmé",
      detail: "demande envoyée",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "demande annulée",
      life: 3000,
    });
  };

  const confirm1 = () => {
    confirmDialog({
      message: "Confirmer l'envoie de la demande?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handleSubmit(),
      reject,
    });
  };

  // ------------------------------------------------------------

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className='container-fluid p-5 h1'>
          <h1 className='h3 text-center '>Demande ordre de mission</h1>
        </div>
        <div className='container mb-3'>
          <div className='container mt-3'>
            <div className='input-group mb-3 '>
              <span className='input-group-text' htmlFor='ref_field'>
                Nom et prénom:
              </span>
              <span className='form-control' id='emp_name'>
                {usrInfo.emp_name}
              </span>
            </div>

            <div className='input-group mb-3 '>
              <span className='input-group-text' htmlFor='ref_field'>
                Fonction/ grade:
              </span>
              <span className='form-control' id='emp_role'>
                {displayEmpRole(usrInfo.emp_role)}
              </span>
            </div>

            <div className='input-group mb-3 '>
              <span className='input-group-text' htmlFor='ref_field'>
                Division/atelier/service:
              </span>
              <span className='form-control' id='department'>
                {displayEmpDep(usrInfo.department)}
              </span>
            </div>

            <div className='input-group mb-3 '>
              <span className='input-group-text' htmlFor='ref_field'>
                Destination:
              </span>
              <input
                className='form-control'
                type='text'
                id='travel_order_destination'
                name='travel_order_destination'
                value={formData.travel_order_destination}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    travel_order_destination: e.target.value,
                  })
                }
              />
            </div>

            <div className='input-group mb-3 '>
            <span className='input-group-text' htmlFor='ref_field'>
              Raison de voyage:
            </span>
            <input
              className='form-control'
              type='text'
              id='travel_order_reason'
              name='travel_order_reason'
              value={formData.travel_order_reason}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  travel_order_reason: e.target.value,
                })
              }
            />
            </div>

            <div className='input-group mb-3 '>
            <span className='input-group-text' htmlFor='ref_field'>
              Moyen de transport:
            </span>
            <input
              className='form-control'
              type='text'
              id='travel_order_trans_mean'
              name='travel_order_trans_mean'
              value={formData.travel_order_trans_mean}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  travel_order_trans_mean: e.target.value,
                })
              }
            />
            </div>

            <div className='input-group mb-3 '>
            <span className='input-group-text' htmlFor='ref_field'>
              Date de départ:
            </span>
            <input
              className='form-control'
              type='text'
              id='travel_order_st_date'
              name='travel_order_st_date'
              value={formData.travel_order_st_date}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  travel_order_st_date: e.target.value,
                })
              }
            />
            </div>

            <div className='input-group mb-3 '>
            <span className='input-group-text' htmlFor='ref_field'>
              Date de retour:
            </span>
            <input
              className='form-control'
              type='text'
              id='travel_order_en_date'
              name='travel_order_en_date'
              value={formData.travel_order_en_date}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  travel_order_en_date: e.target.value,
                })
              }
            />
            </div>
          </div>
        </div>

        <div>
          <label className='form-label' htmlFor=''>
            signature de l'intéressé, Avis du résponsable directe, Avis du
            directeur de l'UDES *
          </label>
        </div>

        {/* <label htmlFor="req_status">Request Status</label>
      <select
        id="req_status"
        name="req_status"
        value={formData.req_status}
        onChange={(e) => setFormData({ ...formData, req_status: e.target.value })}
      >
        <option value="Pending">Pending</option>
        <option value="Approved">Approved</option>
        <option value="Rejected">Rejected</option>
      </select> */}

        {/* <button type='submit'>Submit</button> */}
      </form>
      {/* confirmation dialog ----------------------------------------- */}
      <Toast ref={toast} />

      <div className='p-confirm-dialog	'>
        <ConfirmDialog className='p-confirm-dialog' />
      </div>

      <Button
        id='btn-submit-form'
        onClick={confirm1}
        icon='pi pi-check'
        label='soumettre'
        className='mr-2 btn btn-primary btn-submit-form'
      ></Button>

      {/* confirmation dialog ----------------------------------------- */}
      <Toast ref={toast} />
    </div>
  );
};

export default Form10;
